<template>
<div class="kls-donate-form">
    <div class="form-container ou-donation-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
                <FormSection title="Contribution Amount">
                    <div class="amounts">
                        <AmountSelectorKls/>
                        <ErrorLabel field="amount" />
                    </div>
                    <div class="frequency">
                      <PaymentOptions addSplit addMonthly monthesSelector/>
                    </div>
                </FormSection>
                <FormSection title="Contact Info">
                  <div  class="contact-info">                    
                    <FormRow inline>      
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <DonorAddress />
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>
                    <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>                           
                    <FormRow inline>
                      <div>
                        <FormRow>
                            <FormLabel class="control-label">
                              How would you like your name listed? <br/>
                              <small>(to make your gift anonymous leave this field blank.)</small>
                          </FormLabel>
                        </FormRow>
                        <FormRow>
                          <FormInput class="width-half" field="custom.listedName"/>
                        </FormRow>
                      </div>
                    </FormRow>
                    <FormRow inline>
                      <FormCol field="dedication" :flex="1">
                        <option value="In honor of">In honor of</option>
                        <option value="In memory of">In memory of</option>
                      </FormCol>
                      <FormCol field="dedicationMessage"  :flex="3"/>
                    </FormRow>
                  </div>
                </FormSection>
                <FormSection title="Payment Info" last>
                  <div class="payment-info">
                    <FormRow inline>
                    <FormCol field="card" :showLabel="false"/>
                    </FormRow>
                  </div>
                </FormSection>
                <div class="payment-btn">
                  <PaymentButton btnText="Make contribution"/>
                </div>
            </PaymentForm>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'
import AmountSelectorKls from './amount-selector-kls.vue'

export default defineComponent({
  components: {
    AmountSelectorKls,
  },
  props: {
    subCampaign: String,
  },
  setup() {
    const { form, submit } = usePaymentForm()

    return {
      form,
      submit,
    }
  },
})
</script>
<style scoped lang="scss">
.form-container.ou-donation-form {
  max-width: 900px;
  margin: 60px auto;
}
::v-deep h2 {
  color: rgb(143, 124, 41);
  font-size: 22px;
  font-weight: 200;
  text-transform: uppercase;
  letter-spacing: 3px;
  text-align: center;
  margin-bottom: 40px;
}
::v-deep hr {
  border-bottom: 2px solid #f3ebcf;
  margin-bottom: 50px;
  border-top: none;
  display: block;
  margin-top: 0;
}
.kls-donate-form ::v-deep .styled-radio-container--ou-donation.styled-radio-container {
  justify-content: center;
  .radio-part {
    min-width: 200px;
  }
  label {
    border: 2px solid #f3eccf;
    background: white;
    font-size: 14px;
    color: rgb(84, 52, 40);
    text-transform: uppercase;
    letter-spacing: 2px;
    font-weight: normal;
  }
  input[type='radio']:checked + label {
    background: none;
    color: rgb(84, 52, 40);
    background-image: radial-gradient(
      ellipse at center,
      #f9f6e9 0%,
      #ffffff 5%,
      rgba(124, 80, 134, 0.4117647058823529) 100%
    );
  }
  label:hover {
    background: none;
    background-image: radial-gradient(
      ellipse at center,
      #f9f6e9 0%,
      #ffffff 5%,
      rgba(124, 80, 134, 0.1) 100%
    );
  }
}
::v-deep .control-label {
  text-transform: uppercase;
  color: #26184d;
  font-weight: 400;
  letter-spacing: 2px;
  font-size: 13px;
  max-width: none;
  line-height: 1.4;
}
.contact-info,
.payment-info {
  max-width: 600px;
  margin: auto;
}
.payment-info ::v-deep .cc-field {
  margin: auto;
}
.contact-info ::v-deep input,
.contact-info ::v-deep select {
  border: 2px solid #e8e2e1 !important;
  background-color: white !important;
}
::v-deep .vue-tel-input {
  border: 2px solid #e8e2e1 !important;
  .dropdown {
    background-color: white !important;
    border: none !important;
  }
  input {
    border: none !important;
  }
}
::v-deep .monthly-note {
  max-width: 470px;
  margin: auto;
  select {
    border: 2px solid #e8e2e1 !important;
    background-color: white !important;
    height: 50px;
  }
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.payment-btn ::v-deep .payment {
  justify-content: center;
  .btn-flex {
    background-color: rgba(241, 232, 201, 1);
    color: black;
    border: none;
    font-weight: normal;
    letter-spacing: 1px;
    text-transform: uppercase;
    font-size: 13px;
    padding: 12px 25px;
  }
}
</style>

